import React from "react";

const TableRow = ({ data, index }) => {
  const { date, referenceId, itemname, status } = data;
  return (
    <div
      className={`h-12   ${
        (index + 1) % 2 !== 0 ? "bg-[#F7F9FE]" : "bg-white"
      } pl-2 flex gap-5 items-center font-Lato font-semibold text-base text-[#1E1E1E] cursor-pointer`}
      //   onClick={() => dispatch(openBackdropWithData(data))}
    >
      <input
        type="checkbox"
        className="w-5 h-5 outline-none border-[0.5px] border-[#DEE2F3] focus:outline-none"
      />

      <div className="w-28">{date}</div>
      <div className="w-[150px] xl:w-[225px]">{referenceId}</div>
      <div className="w-[150px] xl:w-[225px]">{itemname}</div>
      <div
        className={`w-[93px] text-center rounded-[200px] h-[25px] ${
          status === "Successful"
            ? "bg-[#E7FFF0]"
            : status === "Pending"
            ? "bg-[#FFEEAE]"
            : "bg-[#FFD2D4]"
        } ${
          status === "Successful"
            ? "text-[#02A443]"
            : status === "Pending"
            ? "text-[#FF9900]"
            : "text-[#A91F24]"
        }`}
      >
        {status}
      </div>
    </div>
  );
};

export default TableRow;
